import React from "react";
import ProductSideService from "./ProductSideService";
import BgImg from "../../assets/portfolio/bg2.png";
import OurClients from "../OurClients/OurClients";
import BulkSMSimage from "../../assets/product/bulk-sms.png";
import BulkSmsHero from "../../assets/product/bulk-sms-Hero.png";
import {
  faCommentDots,
  faMobileAlt,
  faSignal,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BulkSMS = () => {
  const pillars = [
    {
      title: "Message Broadcasting",
      description:
        "Send promotional, transactional, and alert messages to large audiences instantly.",
      icon: faCommentDots,
      bgColor: "bg-blue-100",
    },
    {
      title: "Contact Management",
      description:
        "Organize and manage contact lists for efficient targeting and personalized messaging.",
      icon: faMobileAlt,
      bgColor: "bg-green-100",
    },
    {
      title: "Delivery Tracking & Analytics",
      description:
        "Monitor delivery status and engagement metrics to optimize campaign performance.",
      icon: faSignal,
      bgColor: "bg-yellow-100",
    },
    {
      title: "Campaign Optimization",
      description:
        "Analyze campaign results and refine strategies for higher reach and better ROI.",
      icon: faChartBar,
      bgColor: "bg-red-100",
    },
  ];
  return (
    <div>
      {/* Hero section */}
      <div className="relative bg-gradient-to-r from-[#0B0F2F] to-[#12164E] text-white py-10 px-4 md:px-8 lg:px-8 overflow-hidden">
        {/* Decorative Background Circles */}
        <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-blue-500 opacity-30 rounded-full blur-3xl z-0" />
        <div className="absolute bottom-[-150px] right-[-100px] w-[400px] h-[400px] bg-main1  opacity-20 rounded-full blur-3xl z-0" />

        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Text Content */}
          <div>
            <h1 className="text-2xl md:text-4xl lg:text-4xl font-bold leading-tight text-[#8cd3fe]">
              Bulk SMS
            </h1>
            <p className="md:mt-6 mt-4 text-gray-300 text-[15px] md:text-lg">
              The Bulk SMS Management System helps businesses communicate with
              large audiences instantly, ensuring important messages reach
              customers on time. It enables the sending of promotional offers,
              alerts, and updates to multiple contacts simultaneously. By
              streamlining mass messaging, businesses can boost engagement,
              improve customer outreach, and enhance marketing efficiency.
            </p>
            <button className="hidden md:block mt-8 px-6 py-3 rounded-full bg-main1 hover:bg-[#1c7ed6] text-white font-medium transition">
              Know More
            </button>
          </div>

          {/* Right Image/Graphic Content */}
          <div className="flex justify-center items-center">
            <img
              src={BulkSmsHero}
              alt="Bulk-sms"
              className="w-full max-w-md md:max-w-md lg:max-w-md"
            />
          </div>
        </div>
      </div>
      <div className="md:py-5  py-1 ">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-semibold text-center mt-4 mb-2 text-gray-600">
          Bulk SMS
        </h2>
        <div className=" w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        <p className="text-center text-sm md:text-base text-gray-700 px-4 md:px-20 lg:px-40">
          Efficiently send, track, and manage bulk messages to engage customers,
          promote services, and drive business growth. Boost communication,
          increase outreach, and enhance marketing efficiency with instant SMS
          delivery.
        </p>

        {/* Wrapper that allows scrolling */}
        <div className="px-  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}

          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full md:order-1 order-2 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <img
                  src={BulkSMSimage}
                  alt="BulkSMSimage"
                  className="w-full h-full  object-contain"
                />
              </div>

              {/* Text Content Section */}
              <div className="space-y-4 md:text-base  text-sm order-2 md:order-1 ">
                <div>
                  <div className=" py-2">
                    <h2 className="md:text-xl text-lg font-semibold text-main">
                      Bulk SMS Service can be provided in two ways Promotional
                    </h2>
                    <p className="text-justify text-sm md:text-base mt-1">
                      The promotional SMS like property sale, discount, offers,
                      etc., which can be sent to multiple users just for the
                      sake of promotion.
                    </p>
                  </div>
                  <div className=" py-2">
                    <h2 className="md:text-xl text-lg font-semibold text-main">
                      Transactional
                    </h2>
                    <p className="text-justify text-sm md:text-base mt-1">
                      Transactional SMS basically deals with information-related
                      messages. For example, an SMS sent by the bank about the
                      transaction. We provide the best transactional and
                      promotional Bulk SMS Packages at affordable costs.
                      Campaigning is a major strategy for promoting various
                      business models across 360-degree dimensions. Bulk SMS is
                      an effective campaigning solution that is responsible for
                      sending bulks of lakhs of SMS to many customers.
                      <br />
                      SMS Marketing is a prospect we always were excited to
                      explore. We have effectively planned and delivered many
                      bulk SMS service campaigns for our customers and are
                      really eager to share it with all those who are looking
                      for an effective medium to reach out to clients within
                      seconds at prices that meet the budget. Bulk SMS has
                      proved to be a new way of communication between the sender
                      and receiver. The sender can send his message at a time to
                      multiple users. Deetya soft provides you the liberty of
                      sending SMS from anywhere, any time
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sticky Sidebar */}
          <div className="sticky  top-20 self-start  p-3  h-fit">
            <ProductSideService />
          </div>
        </div>
      </div>

      <div
        className="py-5 px-5 relative"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-2xl md:text-4xl font-semibold">
            <span className="text-black"> Bulk SMS</span>
            <span className="text-sky-500"> Management </span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-300 md:w-[200px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-500 text-base mt-4">
            What You Get Using Our Inventory Management System
          </p>
        </div>

        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {pillars.map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-8 text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                  >
                    <FontAwesomeIcon
                      icon={pillar.icon}
                      className="text-sky-500 text-2xl"
                    />
                  </div>
                  <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                    {pillar.title}
                  </h5>
                  <p className="text-gray-600 text-sm">{pillar.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* client section */}
      <div>
        <OurClients />
      </div>
    </div>
  );
};

export default BulkSMS;
